"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _link = _interopRequireDefault(require("@clayui/link"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["children", "className", "disabled", "displayType", "href", "tag", "truncate"];
/**
 * SPDX-FileCopyrightText: © 2019 Liferay, Inc. <https://liferay.com>
 * SPDX-License-Identifier: BSD-3-Clause
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
var Description = function Description(_ref) {
  var children = _ref.children,
    className = _ref.className,
    disabled = _ref.disabled,
    displayType = _ref.displayType,
    href = _ref.href,
    _ref$tag = _ref.tag,
    Tag = _ref$tag === void 0 ? 'p' : _ref$tag,
    _ref$truncate = _ref.truncate,
    truncate = _ref$truncate === void 0 ? true : _ref$truncate,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var InnerTag = href && !disabled ? _link.default : 'span';
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
    className: (0, _classnames.default)(className, "card-".concat(displayType)),
    title: children ? children.toString() : undefined
  }, otherProps), truncate ? /*#__PURE__*/_react.default.createElement("span", {
    className: "text-truncate-inline"
  }, /*#__PURE__*/_react.default.createElement(InnerTag, {
    className: "text-truncate",
    href: disabled ? undefined : href
  }, children)) : children);
};
var _default = exports.default = Description;